import React, { useEffect, useState } from "react";
import { Logo } from "./Logo";
import { NavigationMenu } from "./components/sidebar/NavigationMenu";
import FreeTrialAccountCard from "./components/sidebar/FreeTrialAccountCard";
import LogoutButton from "./components/logout/LogoutButton";
import { baseAxios } from "./apis";
import { useAuth } from "./context/authContext";

const MiniLinks = () => {
  return (
    <div className="mt-4 flex flex-col gap-2 px-2">
      {/* Divider line to separate from content above */}
      <div className="h-px w-full bg-gray-200 mb-2"></div>

      <div className="flex flex-col gap-1.5 text-[11px] font-medium text-gray-500">
        <div className="flex gap-x-4">
          <a
            href="/terms-of-use"
            className="hover:text-purple-600 transition-colors"
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms of Use
          </a>
          <a
            href="/privacy-policy"
            className="hover:text-purple-600 transition-colors"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>
        </div>
        <a
          href="https://xenorize.freshdesk.com/support/tickets/new"
          className="hover:text-purple-600 transition-colors"
          target="_blank"
          rel="noopener noreferrer"
        >
          Contact Us
        </a>

        {/* Optional Copyright Text */}
        <span className="text-[10px] text-gray-400 mt-1">© 2025 Xenorize</span>
      </div>
    </div>
  );
};

export default function Sidebar({ isOpen, onClose }) {
  const { subscription } = useAuth();

  const trialStartUnix = subscription?.trial_start;
  const trialEndUnix = subscription?.trial_end;

  // const trialStartISO = trialStartUnix
  //   ? new Date(trialStartUnix * 1000).toISOString()
  //   : null;
  // const trialEndISO = trialEndUnix
  //   ? new Date(trialEndUnix * 1000).toISOString()
  //   : null;

  return (
    <>
      <div
        className={`fixed xl:static xl:flex h-[100dvh] top-0 w-full max-w-[260px] min-w-[260px] bg-[#F9F8FC] border-r border-l border-[#dde1e6] py-5 px-4 flex flex-col z-[995] 
         overflow-y-auto scrollbar-thin ${!isOpen ? "hidden" : "flex"}
        `}
      >
        <Logo />
        <NavigationMenu />

        <div className="mt-auto ">
          {(() => {
            // 1. No subscription at all → show free trial
            if (!subscription) {
              return (
                <FreeTrialAccountCard
                  trialStartDate={null}
                  trialEndDate={null}
                />
              );
            }

            // 2. If user is on free plan → show free trial card
            if (subscription?.metadata?.type === "free_trial") {
              const startISO = subscription?.created
                ? new Date(subscription.created * 1000).toISOString()
                : null;

              const endISO = subscription?.cancel_at
                ? new Date(subscription.cancel_at * 1000).toISOString()
                : null;

              return (
                <FreeTrialAccountCard
                  trialStartDate={startISO}
                  trialEndDate={endISO}
                  isFreeTrial={true}
                />
              );
            }

            // 3. If cancel_at exists AND still before that date → show trial card only if ≤ 30 days left
            if (
              subscription?.cancel_at &&
              subscription.cancel_at * 1000 > Date.now()
            ) {
              const msLeft = subscription.cancel_at * 1000 - Date.now();
              const daysLeft = msLeft / (1000 * 60 * 60 * 24);

              if (daysLeft > 30) return null; // ← tambah ini

              const startISO = subscription?.created
                ? new Date(subscription.created * 1000).toISOString()
                : null;
              const endISO = new Date(
                subscription.cancel_at * 1000,
              ).toISOString();

              return (
                <FreeTrialAccountCard
                  trialStartDate={startISO}
                  trialEndDate={endISO}
                />
              );
            }

            // 4. User already has a paid plan → hide the trial card
            return null;
          })()}

          <MiniLinks />
        </div>
      </div>
      <div
        className={`w-full h-full bg-black/60 fixed top-0 z-[994] ${
          !isOpen ? "hidden" : "flex"
        }`}
        onClick={onClose}
      ></div>
    </>
  );
}
